import { ReactRenderer } from '@tiptap/react';
import MentionList from './MentionList';

export const createMentionSuggestion = (axiosInstance, organizationSlug) => {
  let users = []; // Cache users list

  const filterUsers = (query) => {
    return users
      // Filter by name match (case-insensitive)
      .filter(user => (
        user.name.toLowerCase().includes(query.toLowerCase()) ||
        user.initials?.toLowerCase().includes(query.toLowerCase())
      ))
      // Sort by how closely the name matches the query
      .sort((a, b) => {
        const aStartsWith = a.name.toLowerCase().startsWith(query.toLowerCase());
        const bStartsWith = b.name.toLowerCase().startsWith(query.toLowerCase());
        if (aStartsWith && !bStartsWith) return -1;
        if (!aStartsWith && bStartsWith) return 1;
        return 0;
      })
      // Limit to 5 results
      .slice(0, 5)
      // Map to the format needed by the mention list
      .map(user => ({
        userId: user.id,
        userName: user.name,
        initials: user.initials || user.name.split(' ').map(n => n[0]).join(''),
        avatarColor: user.avatarColor,
      }));
  };

  return {
    items: async ({ query }) => {
      try {
        // Only fetch users if we haven't already
        if (users.length === 0) {
          const response = await axiosInstance.get(`/organizations/${organizationSlug}/users`);
          users = response.data;
        }
        
        return filterUsers(query);
      } catch (error) {
        console.error('Error fetching users for mentions:', error);
        return [];
      }
    },

    render: () => {
      let component;
      let clickHandler;

      return {
        onStart: props => {
          component = new ReactRenderer(MentionList, {
            props,
            editor: props.editor,
          });

          // Position the element
          const element = component.element;
          element.style.position = 'absolute';
          const coords = props.clientRect();
          element.style.left = `${coords.left}px`;
          element.style.top = `${coords.top + coords.height}px`;
          document.body.appendChild(element);

          // Add click outside handler
          clickHandler = (e) => {
            if (!element.contains(e.target)) {
              component?.destroy();
            }
          };
          document.addEventListener('click', clickHandler);
        },

        onUpdate(props) {
          component?.updateProps(props);
        },

        onKeyDown(props) {
          if (props.event.key === 'Escape') {
            component?.destroy();
            return true;
          }
          return component?.ref?.onKeyDown(props);
        },

        onExit() {
          document.removeEventListener('click', clickHandler);
          component?.destroy();
        },
      };
    },
  };
}; 